import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const ProjectMain = () => {
    const [apiProjects, setApiProjects] = useState([]);

    // Static project object
    const staticProject = {
        id: -1,
        title: 'Delivering success through logistics',
        content: 'Infrastructure That Inspires Confidence',
    };

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_BASE_URL}/api/infrastructure/`)
            .then(response => response.json())
            .then(data => setApiProjects(data))
            .catch(error => console.error(error));
    }, []);

    return (
        <React.Fragment>
            {/* Project Page Start */}
            <section className="project-one">
                <div className="container">
                    {/* Static Project Section */}
                    <div className="row">
                        <div className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="100ms">
                            <div className="project-two__single">
                                <div className="project-two__content-box">
                                    <div className="text-left section-title">
                                        <div className="section-title__tagline-box">
                                            <span className="section-title__tagline">Latest project</span>
                                        </div>
                                        <h2 className="section-title__title">{staticProject.content}</h2>
                                    </div>
                                    <div className="project-two__btn-box">
                                        <Link to="/contact" className="thm-btn project-two__btn">
                                            Get In touch <span />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Carousel for Upcoming Projects from API */}
                    <div style={{ marginTop: '20px' }}>
                        <Swiper
                            modules={[Navigation, Pagination]}
                            spaceBetween={20}
                            slidesPerView={3}
                            navigation
                            pagination={{ clickable: true }}
                            breakpoints={{
                                320: { slidesPerView: 1, spaceBetween: 10 },
                                640: { slidesPerView: 2, spaceBetween: 15 },
                                1024: { slidesPerView: 3, spaceBetween: 20 },
                            }}
                        >
                            {apiProjects.map((project, index) => (
                                <SwiperSlide key={project.id}>
                                    <div className="project-two__single">
                                        <div className="project-two__img">
                                            <img src={project.image} alt={project.title} style={{ width: "800px", height: "400px", objectFit: "cover" }} />
                                            <div className="project-two__content">
                                                <p className="project-two__sub-title">{project.category}</p>
                                                <h3 className="project-two__title">
                                                    <Link to={`/infrastructure-details/${project.slug}`}>
                                                        {project.title}
                                                    </Link>
                                                </h3>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            </section>
            {/* Project Page End */}
        </React.Fragment>
    );
};

export default ProjectMain;
